import React, { useState } from "react";

import { processImage } from "./ImageUtils";

const ImageUploader = ({
  label,
  description,
  image,
  onUpload,
  onClear,
  onError,
  required = false,
  height = 192, // Default roughly h-48 (12rem)
  isGrpPreview = false
}) => {
  const [isProcessing, setIsProcessing] = useState(false);

  const handleChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      setIsProcessing(true);
      try {
        const processed = await processImage(file);
        if (processed) {
          await onUpload(processed);
          setIsProcessing(false);
        }
      } catch (err) {
        console.error("Image processing error:", err);
        alert(`"Image processing error:", ${err}`);
        if (onError) {
          onError(err.message || "Failed to process image");
        }
      }
      // Reset input so the same file can be uploaded again if cleared
      // e.target.value = "";
    }
  };

  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  const handleLoad = (event) => {
    const { naturalWidth, naturalHeight } = event.target;
    setDimensions({ width: naturalWidth, height: naturalHeight });
  };

  return (
    <div className="flex flex-col space-y-2 w-full">
      <div className="flex justify-between items-center">
        <label className="text-sm font-semibold text-slate-300">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
        {image && (
          <button
            onClick={onClear}
            className="text-xs text-red-400 hover:text-red-300 transition-colors"
          >
            Remove
          </button>
        )}
      </div>

      <div
        style={{ height: `${height}px` }}
        //  className={`relative w-full group rounded-xl border-2 border-dashed transition-all duration-200
        className={`relative flex justify-center group rounded-xl border-2 border-dashed transition-all duration-200 
        ${
          image
            ? "border-indigo-500/50"
            : "border-slate-700 hover:border-slate-500 hover:bg-slate-800/30"
        }
        
        ${isProcessing ? "bg-slate-800/50 border-indigo-500/50" : ""}`}
      >
        {isProcessing ? (
          <div className="flex flex-col items-center justify-center h-full p-4 text-center">
            <div className="w-8 md:h-8 border-2 border-indigo-500 border-t-transparent rounded-full animate-spin mb-2"></div>
            <span className="text-[10px] font-bold text-indigo-400 uppercase tracking-widest animate-pulse">
              Processing...
            </span>
          </div>
        ) : image ? (
          <img
            src={image.preview}
            alt="Preview"
            className="h-full w-full object-contain rounded-lg"

            // onLoad={handleLoad}
            // // className="w-full h-auto max-h-[50vh] lg:max-h-none lg:h-full object-contain lg:object-cover"
            // className={
            //   isGrpPreview
            //     ? "h-full object-vover rounded-lg"
            //     : dimensions.width > dimensions.height
            //     ? "w-full object-cover rounded-lg"
            //     : "h-full object-cover rounded-lg"
            // }
          />
        ) : (
          <div className="flex flex-col items-center justify-center h-full p-4 text-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              // className="h-8 w-8 text-slate-500 mb-2"
              className="w-8 text-slate-500 mb-2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 4v16m8-8H4"
              />
            </svg>
            <span className="text-xs font-medium text-slate-400">
              {description}
            </span>
            <input
              type="file"
              accept="image/*,.heic,.heif,.avif"
              className="absolute inset-0 opacity-0 cursor-pointer w-full h-full"
              onChange={handleChange}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageUploader;
